<div class="purchase-scope">
  <div *ngIf="isLoading" class="purchase-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading your purchases…</p>
  </div>

  <div class="purchase-empty" *ngIf="purchaseHitory.length === 0 && !isLoading">
    <div class="purchase-empty-icon" aria-hidden="true">🛍️</div>
    <h3>No purchases yet</h3>
    <p>Your purchase history will appear here after you buy webinar seats.</p>
  </div>

  <ng-container *ngIf="!isLoading && purchaseHitory.length > 0">
    <div class="purchase-hero">
      <p class="purchase-kicker">Your seats</p>
      <h1 class="purchase-heading">Hi {{ firstName }}</h1>
      <p class="purchase-sub">Here are the webinars you’ve grabbed a seat in.</p>
    </div>

    <div class="purchase-grid" [attr.data-count]="purchaseHitory.length">
      <article class="purchase-card" *ngFor="let row of purchaseHitory">
        <div class="card-top-bar">
          <span class="purchase-tag">
            <mat-icon class="purchase-tag-icon">shopping_bag</mat-icon>
            Purchase
          </span>
          <div class="card-top-badges">
            <span class="price-badge-top">{{ row.totalPrice | currency }}</span>
            <span class="seats-badge-top">
              {{ row.seatPurchased }} seat{{ row.seatPurchased === 1 ? '' : 's' }}
            </span>
          </div>
        </div>

        <div class="live-run-banner" *ngIf="isRunActive(row)">
          <span class="live-run-label">{{ getRunLabel(row) }}</span>
          <button type="button" class="account-cta account-cta--compact" (click)="openWebinarRun(row)">
            Open
          </button>
        </div>

        <div class="purchase-card-media">
          <div class="media-frame">
            <img
              [src]="row.imageUrl || 'assets/Images/demo1.png'"
              [alt]="row.productReview"
              onerror="this.src='assets/Images/demo1.png'" />
          </div>
        </div>

        <div class="purchase-card-body">
          <h3 class="purchase-card-title">{{ row.productReview }}</h3>

          <div class="purchase-meta-grid">
            <div class="meta-item" *ngIf="getRoomName(row)">
              <span class="meta-icon" aria-hidden="true">🏪</span>
              <div class="meta-text">
                <span class="meta-label">Room</span>
                <span class="meta-value">{{ getRoomName(row) }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="row.createdDate">
              <span class="meta-icon" aria-hidden="true">📅</span>
              <div class="meta-text">
                <span class="meta-label">Date</span>
                <span class="meta-value">{{ row.createdDate | date: 'dd MMM yyyy' }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="row.orderId" [title]="row.orderId">
              <span class="meta-icon" aria-hidden="true">📋</span>
              <div class="meta-text">
                <span class="meta-label">Order</span>
                <span class="meta-value meta-mono">{{ row.orderId }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="getSeatNumbers(row).length > 0">
              <span class="meta-icon" aria-hidden="true">🪑</span>
              <div class="meta-text">
                <span class="meta-label">Seats</span>
                <div class="seat-chips">
                  <span class="seat-chip" *ngFor="let seat of getSeatNumbers(row)">{{ seat }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="purchase-card-footer video-footer" *ngIf="hasVideos(row)">
          <button
            type="button"
            class="account-cta"
            *ngIf="row.webinarVideopath && row.isWebinarCompleted"
            (click)="openWebinarVideoPopup(row.webinarVideopath)">
            Webinar
          </button>
          <button
            type="button"
            class="account-cta"
            *ngIf="row.videorecordingPath && row.isWebinarCompleted"
            (click)="openVideoPopup(row.videorecordingPath)">
            Recording
          </button>
        </div>
      </article>
    </div>

    <div class="casino-pager">
      <mat-paginator
        class="casino-paginator purchase-paginator"
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        [disabled]="isLoading"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </ng-container>
</div>
